<div class="criar-pergunta-modal__overlay" (click)="onCancelar()">
  <div
    class="criar-pergunta-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="criar-pergunta-modal-title"
    data-testid="criar-pergunta-modal"
    [formGroup]="form()"
    (click)="$event.stopPropagation()"
  >
    <h2 id="criar-pergunta-modal-title" class="criar-pergunta-modal__title">Criar pergunta</h2>

    <label class="campanha-form-label" for="criar-pergunta-texto">
      Enunciado <span class="campanha-form-required">*</span>
    </label>
    <input
      id="criar-pergunta-texto"
      type="text"
      class="form-control campanha-form-control"
      [class.is-invalid]="submitAttempted() && form().get('texto')!.invalid"
      formControlName="texto"
      placeholder="Digite o enunciado da pergunta"
      data-testid="criar-pergunta-texto"
    />
    @if (submitAttempted() && form().get('texto')!.invalid) {
      <div class="invalid-feedback" data-testid="criar-pergunta-texto-error">Campo obrigatório.</div>
    }

    <div class="criar-pergunta-modal__actions">
      <button
        type="button"
        class="btn btn-outline-primary"
        data-testid="criar-pergunta-cancelar"
        (click)="onCancelar()"
      >
        Cancelar
      </button>
      <button
        type="button"
        class="btn btn-primary"
        data-testid="criar-pergunta-criar"
        (click)="onCriar()"
      >
        Criar
      </button>
    </div>
  </div>
</div>
